import { render, staticRenderFns } from "./customStatics.vue?vue&type=template&id=6d199742&"
import script from "./customStatics.vue?vue&type=script&lang=js&"
export * from "./customStatics.vue?vue&type=script&lang=js&"
import style0 from "./customStatics.vue?vue&type=style&index=0&id=6d199742&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports